import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { GetAddendumCosignMetaResponse } from "@/core/types/(api)/cosignature";

export async function getAddendumCosignMeta(
  documentId: string,
): Promise<GetAddendumCosignMetaResponse> {
  return cosignatureRequestsTyped.get_addendum_cosign_meta({ urlParams: { documentId } });
}
